<template>
  <div
    ref="scroll"
    :class="{
      'scroll': !isSkeletonLoader,
      'scroll-skeleton': isSkeletonLoader,
    }"
    v-on:mousedown="mouseDownHandler"
  >
    <slot />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    itemsToShow: {
      type: Number,
      default: 0,
    },
    isSkeletonLoader: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    pos: { top: 0, left: 0, x: 0, y: 0 },
  }),
  computed: {
    ...mapGetters(['windowWidth']),
    slidesToShow() {
      if (this.windowWidth > 1263) {
        return this.itemsToShow || 2;
      }
      if (this.windowWidth > 960) {
        return 3.5;
      }
      if (this.windowWidth > 600) {
        return 2.5;
      }
      return 1.5;
    },
  },
  methods: {
    mouseMoveHandler(e) {
      const dx = e.clientX - this.pos.x;
      this.$refs.scroll.scrollLeft = this.pos.left - dx;
    },
    mouseDownHandler(e) {
      this.pos = {
        left: this.$refs.scroll.scrollLeft,
        x: e.clientX,
      };

      window.addEventListener('mousemove', this.mouseMoveHandler);
      window.addEventListener('mouseup', this.mouseUpHandler);
    },
    mouseUpHandler() {
      window.removeEventListener('mousemove', this.mouseMoveHandler);
      window.removeEventListener('mouseup', this.mouseUpHandler);
    }
  },
};
</script>

<style lang="scss" scoped>
.scroll-skeleton {
  display: flex;
  flex-wrap: nowrap;
  overflow: hidden;
}
.scroll {
  display: flex;
  overflow-x: auto;
  overflow-y: hidden;
  margin-left: -8px;
  padding: 8px;
  width: 100%;
  > div {
    flex: none;
    width: 350px !important;
    &:not(:first-child) {
      margin-left: 16px;
    }
  }
}
.scroll::-webkit-scrollbar {
  display: none;
}
.scroll {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
